import { Truck, Clock, Shield } from "lucide-react"

export default function ShippingInfo() {
  return (
    <section className="my-12 py-8 border-t border-gray-200">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="flex flex-col items-center text-center">
          <div className="bg-[#fff8eb] p-4 rounded-full mb-4 text-[#ff9906]">
            <Truck size={24} />
          </div>
          <h3 className="text-lg font-bold mb-2 text-gray-800">FREE AND FAST DELIVERY</h3>
          <p className="text-sm text-gray-600">Free delivery for all orders over $100</p>
        </div>

        <div className="flex flex-col items-center text-center">
          <div className="bg-[#fff8eb] p-4 rounded-full mb-4 text-[#ff9906]">
            <Clock size={24} />
          </div>
          <h3 className="text-lg font-bold mb-2 text-gray-800">24/7 CUSTOMER SERVICE</h3>
          <p className="text-sm text-gray-600">Friendly 24/7 customer support</p>
        </div>

        <div className="flex flex-col items-center text-center">
          <div className="bg-[#fff8eb] p-4 rounded-full mb-4 text-[#ff9906]">
            <Shield size={24} />
          </div>
          <h3 className="text-lg font-bold mb-2 text-gray-800">MONEY BACK GUARANTEE</h3>
          <p className="text-sm text-gray-600">We return money within 30 days</p>
        </div>
      </div>
    </section>
  )
}
